import { render } from "./Initialization.vue?vue&type=template&id=d45390ce&scoped=true&ts=true"
import script from "./Initialization.vue?vue&type=script&lang=ts"
export * from "./Initialization.vue?vue&type=script&lang=ts"

import "./Initialization.vue?vue&type=style&index=0&id=d45390ce&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45390ce"]])

export default __exports__